import benchmarkAnalysis_ from 'assets/img/landing-icons/pe-benchmark-analysis.png';
import portfolioImpact_ from 'assets/img/landing-icons/pe-portfolio-impact.png';
import BenchmarkAnalysis from 'views/performance-engine/BenchmarkAnalysis';
import PortfolioImpact from 'views/performance-engine/PortfolioImpact';
import HorizontalLanding from 'components/HorizontalLanding';

export const meta = {
  path: '/pe',
  title: 'Performance Engine',
  component: Landing,
  items: [
    {
      path: '/benchmark-analysis',
      title: 'Benchmark Analysis',
      component: BenchmarkAnalysis,
      description:
        'Compare any asset or portfolio versus a selected benchmark to precisely measure relative risk, performance and tracking over time.',
      imgSrc: benchmarkAnalysis_,
      permission: 'pe-benchmark-analysis',
    },
    {
      path: '/portfolio-impact',
      title: 'Portfolio Impact',
      component: PortfolioImpact,
      description:
        'Analyze and quantify the impact of including an asset within an existing portfolio to identify best outcomes.',
      imgSrc: portfolioImpact_,
      permission: 'pe-portfolio-impact',
    },
  ],
};

export default function Landing({ session }) {
  return <HorizontalLanding meta={meta} session={session} className="tw-max-w-5xl" />;
}
